
<div class="px-3">

  <page-title 
      icon="money-bill"
      title="QFund Posts Transactions" 
      description="Analyze the data of custom client http post transactions of Qfund ">
  </page-title>

<div class="mt-4">
    <creditor-autocomplete [creditorFilter]="[54,77,196,214,166,190,195,200]" (onSelect)="onSelectCreditor($event)"></creditor-autocomplete>       
       
    <div class="mt-5 flex gap-2" >
        <div class="p-float-label">
            <p-calendar [(ngModel)]="fromDate"
                        inputId="fromDate"
                        dateFormat="mm/dd/yy"
                        showIcon="true"
                        [showButtonBar]="true">
            </p-calendar>
            <label for="fromDate">From Date</label>
        </div>
        
        <div class="p-float-label">
            <p-calendar [(ngModel)]="toDate"
                        inputId="toDate"
                        dateFormat="mm/dd/yy"
                        showIcon="true"
                        [showButtonBar]="true">
             </p-calendar>
             <label for="toDate">To Date</label>
        </div>
    </div>

    <div class="flex justify-content-end gap-2" style="padding-top: 4px;">
        <remitter-button
                 label="Get"
                 icon='play'
                 severity="primary"
                 (click)="getReport()"
                    />
         <remitter-button
                    label="Export"
                    icon='file-export'
                    severity="secondary"
                    (click)="exportReport()"
                    />
          
        </div>
    </div>

    <div class="mt-4 pt-2 px-3">

       <div 
            *ngIf="!hasTableData && hasClickedSearch"
            style="text-align:center; margin-top:9rem; color: #336699; font-size: 1rem;">
                🚫 No records found for {{ selectedCreditorCompanyName }}
        </div>
        <p-table 
            *ngIf="hasTableData"
            [value]="reportData" 
            [paginator]="true" 
            [rows]="25" 
            [tableStyle]="{ 'min-width': '50rem' }" 
            [rowsPerPageOptions]="[25, 100]">
            <ng-template pTemplate="header">
                <tr class="text-xs">
                    <th>Transaction Correlation Id</th>
                    <th>Invoice Number</th>                    
                    <th>Transaction Id</th>
                    <th>Reference Id</th>
                    <th>Processed On</th>

                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-report>
                <tr class="text-xs">
                    <td>{{ report.transactionCorrelationId }}</td>
                    <td>{{ report.invoiceNumber }}</td>                                 
                    <td>{{ report.transactionId }}</td>
                    <td>{{ report.referenceId }}</td>
                    <td>{{ report.processedOn }}</td>
                </tr>
            </ng-template>
        </p-table>

    </div>
</div>
